import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import { Tabs } from 'antd';
const TabPane = Tabs.TabPane;
const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = null;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" components={components}>
      <MDXTag name="p" components={components}><MDXTag name="a" components={components} parentName="p" props={{
          "href": "/snippets/main/mdx-tabs/"
        }}>{`A snippet`}</MDXTag>{` of markdown to put selected chunks of text to separate tabs`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-javascript"
        }}>{`import {Tabs} from 'antd';
const TabPane = Tabs.TabPane;

........

<Tabs defaultActiveKey="1">
<TabPane tab="Tab 1" key="1">

The *first* line.

The second line.
</TabPane>
<TabPane tab="Tab 2" disabled key="2">
Disabled tab.
</TabPane>
<TabPane tab="Tab 3" key="3">

Another line.

\`\`\`
cd my-project
\`\`\`

</TabPane>
</Tabs>
`}</MDXTag></MDXTag>
      <MDXTag name="p" components={components}>{`Which will produce:`}</MDXTag>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Tab 1" key="1">
          <MDXTag name="p" components={components}>{`The `}<MDXTag name="em" components={components} parentName="p">{`first`}</MDXTag>{` line.`}</MDXTag>
          <MDXTag name="p" components={components}>{`The second line.`}</MDXTag>
        </TabPane>
        <TabPane tab="Tab 2" disabled key="2">
Disabled tab.
        </TabPane>
        <TabPane tab="Tab 3" key="3">
          <MDXTag name="p" components={components}>{`Another line.`}</MDXTag>
          <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{}}>{`cd my-project
`}</MDXTag></MDXTag>
        </TabPane>
      </Tabs>
           </MDXTag>;
  }

}
export const _frontmatter = {
  "title": "Format markdown using Tabs component",
  "keywords": "MDX, markdown, Tabs, Ant Design",
  "menu": "mdx/tabs"
};
    